import React from "react";

const Footer = () => {
  return (
    <footer className="p-6 bg-primary">
      <div>
        <p className="text-white text-center">
          Developed by :{" "}
          <span className="text-accent font-bold">Rafat Hossain</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
